enum DestructionType {
    Extend = 1,
    Destroy = 2
}

export default DestructionType